// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-content {
  height: 100%;
  max-height: 100%;
}
.menu, .admin-container, .admin-content {
  background: white;
  border-radius: 10px;
  margin: 5px;
  max-width: 90%;
  width: 90%;
  max-height: 100%;
  color: white;
  flex: 1 1 100%;
  display: flex;
}
.menu {
  padding: 0px 40px;
  box-shadow: 0 10px 40px rgb(0, 0, 0);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  background-color: rgb( 0, 0, 0); 
  background-color: rgba( 0, 0, 0, 0.5); 
  align-items: center;
  gap: 10px;
  height: 100px;
  width: 90%;
  max-width: 100%;
  max-height: 100px;
}
.admin-container, .admin-content {
  background-color: rgb( 0, 0, 0); 
  background-color: rgba( 0, 0, 0, 0); 
  padding: 40px;
  height: 90%;
  max-height: 90%;
}
.admin-content {
  width: 100%;
  box-shadow: 0 10px 40px rgb(0, 0, 0);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  background-color: rgb( 0, 0, 0); 
  background-color: rgba( 0, 0, 0, 0.8); 
}
.admin-container {
  flex-direction: column;
}

.btn, .btn-primary, .btn-secondary {
  padding: 12px;
  border: 1px solid green;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  align-items: center;
}

.btn-primary {
  background: #667eea;
  color: white;
}

/*
.btn-primary:hover {
  background: #5568d3;
}
*/
.btn-secondary:hover, .btn-right:hover {
  background: #5568d3;
  color: green;
}

.btn-secondary, .btn-right {
  display: flex;
  background: #f0f0f0;
  margin-top: 20px;
  width: auto;
}

.btn-secondary {
  gap: 10px;
  color: #333;
}

.btn-right {
  color: red;
  position: absolute;
  bottom: 30px;
  right: 30px;
}

.btn-secondary:hover, .btn-right:hover {
  background: #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/Work.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;CAIC;AACD;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".test-content {\n  height: 100%;\n  max-height: 100%;\n}\n.menu, .admin-container, .admin-content {\n  background: white;\n  border-radius: 10px;\n  margin: 5px;\n  max-width: 90%;\n  width: 90%;\n  max-height: 100%;\n  color: white;\n  flex: 1 1 100%;\n  display: flex;\n}\n.menu {\n  padding: 0px 40px;\n  box-shadow: 0 10px 40px rgb(0, 0, 0);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  background-color: rgb( 0, 0, 0); \n  background-color: rgba( 0, 0, 0, 0.5); \n  align-items: center;\n  gap: 10px;\n  height: 100px;\n  width: 90%;\n  max-width: 100%;\n  max-height: 100px;\n}\n.admin-container, .admin-content {\n  background-color: rgb( 0, 0, 0); \n  background-color: rgba( 0, 0, 0, 0); \n  padding: 40px;\n  height: 90%;\n  max-height: 90%;\n}\n.admin-content {\n  width: 100%;\n  box-shadow: 0 10px 40px rgb(0, 0, 0);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  background-color: rgb( 0, 0, 0); \n  background-color: rgba( 0, 0, 0, 0.8); \n}\n.admin-container {\n  flex-direction: column;\n}\n\n.btn, .btn-primary, .btn-secondary {\n  padding: 12px;\n  border: 1px solid green;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s;\n  align-items: center;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n}\n\n/*\n.btn-primary:hover {\n  background: #5568d3;\n}\n*/\n.btn-secondary:hover, .btn-right:hover {\n  background: #5568d3;\n  color: green;\n}\n\n.btn-secondary, .btn-right {\n  display: flex;\n  background: #f0f0f0;\n  margin-top: 20px;\n  width: auto;\n}\n\n.btn-secondary {\n  gap: 10px;\n  color: #333;\n}\n\n.btn-right {\n  color: red;\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n}\n\n.btn-secondary:hover, .btn-right:hover {\n  background: #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
